import { NavLink } from 'react-router-dom';
import { YouTubeDisconnectButton } from '@/components/channel/YouTubeDisconnectButton';

const LINKS = [
  { to: '/channel', label: 'Overview', end: true },
  { to: '/channel/videos', label: 'Videos' },
  { to: '/channel/advanced', label: 'Advanced' },
  { to: '/channel/keywords', label: 'Keywords' },
  { to: '/channel/competitors', label: 'Competitors' },
];

export function ChannelSectionNav() {
  return (
    <nav className="flex items-center justify-between gap-4 border-b border-white/[0.06] -mx-1 px-1">
      <div className="flex items-center gap-5 sm:gap-6 min-w-0 overflow-x-auto scrollbar-none">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            `pb-2.5 -mb-px text-sm font-medium border-b-2 transition-colors whitespace-nowrap shrink-0 ${
              isActive
                ? 'text-white border-[#34d399]'
                : 'text-[#7d8799] border-transparent hover:text-white'
            }`
          }
        >
          {link.label}
        </NavLink>
      ))}
      </div>
      <YouTubeDisconnectButton className="mb-1 shrink-0" />
    </nav>
  );
}
